import { forwardRef } from "react";

import { InputBaseProps, RefComponent } from "capitalrx-components-2.0/lib/forms";
import { Placeholder } from "capitalrx-components-2.0/lib/forms/Textbox/Placeholder";
import { SharedProps } from "capitalrx-components-2.0/lib/forms/Textbox/SharedProps";
import { withSubComponents } from "capitalrx-components-2.0/lib/utilities";

import { Field } from "./Field";
import { Input } from "./Input";

/**
 * The `Phonebox` component properties.
 */
export interface PhoneboxProps extends InputBaseProps<string | null>, SharedProps {
  /**
   * Whether to display the country code dropdown selector
   * This will also prefix the input value with the country code, starting with
   * the + symbol
   */
  useCountryCode?: boolean;
}

/**
 * The `Phonebox` component sub components.
 */
export interface PhoneboxSubComponents {
  /**
   * A React Hook Form compatible Phonebox Field component. For more information, see the documentation for
   * the <a href="https://react-hook-form.com/api">React Hook Form API</a>.
   */
  readonly Field: typeof Field;

  /**
   * A placeholder component for the Phonebox which can be displayed while loading.
   */
  readonly Placeholder: typeof Placeholder;
}

/**
 * An input component which allows the user to enter a phone number. The phone-number-input library will always return
 * a phone number with the area code so you must handle that value accordingly.
 * https://gitlab.com/catamphetamine/react-phone-number-input
 */
export const Phonebox = withSubComponents<RefComponent<HTMLInputElement, PhoneboxProps>, PhoneboxSubComponents>(
  {
    Field,
    Placeholder,
  },
  forwardRef<HTMLInputElement, PhoneboxProps>(function Phonebox(props, ref) {
    return <Input {...props} ref={ref} />;
  }),
);
